import { render, staticRenderFns } from "./integrated-toggle.vue?vue&type=template&id=726f4fec&"
import script from "./integrated-toggle.vue?vue&type=script&lang=js&"
export * from "./integrated-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports